import {
  Component,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { BaseDropdownComponent } from '../_base-dropdown.component';


@Component({
  moduleId: module.id,
  selector: 'bootstrap-btn-dropdown',
  templateUrl: 'bootstrap-btn-dropdown.component.html',
})
export class BootstrapBtnDropdownComponent extends BaseDropdownComponent {

  /**
   * Button style ['primary', 'secondary']
  */
  @Input() buttonStyle: string = '';
  @Input() isSingle: boolean = false;
  @Input() buttonTitle: string;
  @Input() alignmentRight: boolean = false;

  get title(): string {
    if (this.buttonTitle) {
      return this.buttonTitle;
    }
    if (this.items && this.items.length) {
      return this.items[0].title;
    } else {
      return '';
    }
  }

}
